export default class SidebarGestureController {
  #onSwipeLeft;

  #threshold;

  #eventCleanups = [];

  constructor({ onSwipeLeft, threshold = 50 }) {
    if (typeof onSwipeLeft !== "function") {
      throw new TypeError(
        "SidebarGestureController requires an onSwipeLeft callback.",
      );
    }

    this.#onSwipeLeft = onSwipeLeft;
    this.#threshold = threshold;
  }

  attach(element) {
    if (!element) return false;

    let gestureStart;
    const resetGesture = () => {
      gestureStart = undefined;
    };
    const finishGesture = (event) => {
      if (!gestureStart) return;

      const distanceX = gestureStart.x - event.clientX;
      const distanceY = Math.abs(gestureStart.y - event.clientY);
      resetGesture();

      if (distanceX >= this.#threshold && distanceX > distanceY) {
        this.#onSwipeLeft();
      }
    };
    const startGesture = (event) => {
      gestureStart = { x: event.clientX, y: event.clientY };
    };

    this.#listen(element, "pointerdown", startGesture);
    this.#listen(element, "pointerup", finishGesture);
    this.#listen(element, "pointerleave", resetGesture);
    this.#listen(element, "pointercancel", resetGesture);
    return true;
  }

  #listen(target, eventName, listener) {
    target.addEventListener(eventName, listener);
    this.#eventCleanups.push(() =>
      target.removeEventListener(eventName, listener),
    );
  }

  destroy() {
    for (const cleanup of this.#eventCleanups.splice(0).reverse()) cleanup();
  }
}
